// extracted by mini-css-extract-plugin
export default {"header":"styles_header__PbCOx","smallTitle":"styles_smallTitle__MkIUm","title":"styles_title__fQCQh","changeRequest":"styles_changeRequest__uXwLd"};